<template>
  <div class="esign-signatory-form">
    <MainForm
        :main-fields="fields"
        submit-position="bottom"
        submit-label="LBL_CONTINUE"
        custom-submit="true"
        @submit="handleFormSubmit"
        :custom-submit-in-progress="signingInProgress"
        :submit-possible-only-on-changes="false"
        :readonly="readonly"
    >
      <template #title>
        <div>
          {{$t('LBL_SIGNATORY_FORM_GUIDE')}}
        </div>
      </template>
    </MainForm>
  </div>
</template>

<script>

import MainForm from "@/components/MainForm.vue";

export default {
  props: {
    signingInProgress: {
      type: Boolean,
      default: false
    },
    signatory: {
      type: Object,
      required: false,
      default: () => ({
        firstName: '',
        lastName: '',
        email: '',
        cellPhone: ''
      })
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  emits: ['submit'],

  computed: {
    fields() {
      return [
        { name: 'firstName', type: 'string', label: this.$t('LBL_FIRST_NAME'), editable: true, mandatory: true, 'max-length': 100, 'is-float': true, value: this.signatory.firstName },
        { name: 'lastName', type: 'string', label: this.$t('LBL_LAST_NAME'), editable: true, mandatory: true, 'max-length': 100, 'is-float': true, value: this.signatory.lastName },
        { name: 'email', type: 'email', label: this.$t('LBL_EMAIL'), editable: true, mandatory: true, 'max-length': 100, 'is-float': true, value: this.signatory.email },
        { name: 'cellPhone', type: 'phone', label: this.$t('LBL_CELL_PHONE'), editable: true, mandatory: true, 'max-length': 40, 'is-float': true, value: !this.signatory.cellPhone ? '+33' : this.signatory.cellPhone },
      ];
    }
  },

  components: {
    MainForm
  },

  methods: {
    handleFormSubmit({ formData }) {
      this.$emit('submit', { ...formData })
    }
  }
}
</script><style lang="scss">@import "@/assets/scss/components/Esign/_esignsignatoryform.scss";</style>